<template>
  <div class="noaccess-page">
    <TopBar slot="topbar">
      <template #left>
        <LogoCampaign slot="logo" class="logo--campaign" />
      </template>

      <template #right>
        <UserMenu
          :name="getProfile.FullName"
          :company="getConfig.PartnerName"
          :logo="getConfig.PartnerIcoURL"
        />
        <button
          class="top-bar__logout-button"
          @click="logout"
        >
          <img src="@/manzana_library/assets/images/logout.svg" alt="Logo" />
        </button>
      </template>
    </TopBar>

    <div class="noaccess-page__text-block">
      <h2>Ошибка доступа</h2>
      <p>
        Нет настройки прав. Обратитесь в службу поддержки.
      </p>
    </div>
  </div>
</template>

<script>
import LogoCampaign from "@/components/Icons/LogoCampaign.vue";
import UserMenu from '@/manzana_library/components/Layout/UserMenu';
import TopBar from '@/manzana_library/components/CmLayout/TopBar';

import AuthenticationService from "@/services/AuthenticationService";

import { mapGetters } from "vuex";

export default {
  name: "NoAccess",

  components: {
    LogoCampaign,
    UserMenu,
    TopBar
  },

  computed: {
    ...mapGetters({
      getProfile: "getProfile",
      getConfig: "getConfig"
    }),
  },

  methods: {
    async logout() {
      AuthenticationService.logout();
      await this.$store.dispatch("REMOVE_TOKEN");
      this.$router.push({ name: "login" });
      setTimeout(() => {
        this.$store.dispatch("AUTH_LOGOUT");
      }, 1000);
    }
  }
}
</script>

<style lang="scss">
.noaccess-page {
  height: 100%;
  .logo--campaign {
    height: 30px;
  }
  &__text-block {
    height: calc(100% - 47px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h2 {
      color: $color_error;
      margin-bottom: 15px;
    }
  }
}
</style>
